//Node modules
require('jquery')
import moment from 'moment'
window.moment = moment
require('moment-timezone')

//Custom JS
import './modules/navigation.js'

